var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"mr-2",attrs:{"type":"is-warning"},on:{"click":_vm.back}},[_vm._v("Annuler")])}
var staticRenderFns = []

export { render, staticRenderFns }